<template>
  <div class="clearfix">
    <a-select
      showSearch
      labelInValue
      :value="selectedUsers"
      style="width: 100% "
      :filterOption="false"
      @search="fetchUser"
      @change="handleChange"
      :notFoundContent="fetching ? loading : '无相关用户'"
      placeholder="请输入用户名"
      :size="size"
      mode="multiple"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
      <a-select-option v-for="user in likeUsers" :key="user.uid" ><a-avatar :src="user.avatar" style="margin:5px 10px 5px 0"/>{{ user.user_name }}</a-select-option>
    </a-select>
  </div>
</template>

<script>
import { getAllUserList } from '@/api/user'

export default {
  name: 'SelectUser',
  data () {
    this.lastFetchId = 0
    return {
      fetching: false,
      likeUsers: [],
      selectedUsers: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      visible: false,
      confirmLoading: false,
      mdl: {},
      size: 'middle'
    }
  },
  created () {
    this.fetchUser('')
  },
  methods: {
    fetchUser (value) {
      this.lastFetchId += 1
      const fetchId = this.lastFetchId
      this.likeUsers = []
      this.data = []
      this.fetching = true
      var conditions = {}
      if (value)conditions.q = value
      // if(this.$store.getters.projectId)conditions.item_id = this.$store.getters.projectId

      getAllUserList(conditions).then(
        res => {
          //
          if (fetchId !== this.lastFetchId) { // for fetch callback order
            return
          }
          const _likeUsers = this.likeUsers = []
          //
          if (res.data.length != 0) {
            res.data.map(user => {
              _likeUsers.push({
                user_name: user.user_name,
                uid: user.uid,
                avatar: user.user_avatar
              })
            })
          }

          this.fetching = false
        }
      ).catch(() => {
        //
        this.fetching = false
      })
    },
    handleChange (values) {
      //
      const selectedUsers = this.selectedUsers = []
      values.map(user => {
        selectedUsers.push(Object.assign({
          uid: user.key,
          user_name: user.label[1].text
        }, user))
      })
      this.size = 'large'
      this.fetching = false
    }
  }
}
</script>
